import Head from 'next/head';
import { useExternalConfig } from '@poplar/contexts/ExternalConfig';
import { jsx as _jsx } from "react/jsx-runtime";
export var AppleItunesApp = function AppleItunesApp() {
  var _useExternalConfig = useExternalConfig(),
      appleAppId = _useExternalConfig.appleAppId;

  return /*#__PURE__*/_jsx(Head, {
    children: /*#__PURE__*/_jsx("meta", {
      name: "apple-itunes-app",
      content: "app-id=".concat(appleAppId)
    }, "apple-itunes-app")
  });
};